import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from "../context/LanguagesContext";

import { Loader } from './components/Loader'
import { Toaster } from './components/Toaster'
import { NewFormBlock } from './components/NewFormBlock'
import { Link } from 'react-router-dom'

import { Tabs, Tab } from 'react-bootstrap';  // Button, Form, Row, Col, Card, Accordion, Tabs, Tab, Badge, Table
import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
import { IconContext } from "react-icons";
import EditableSpan from "./components/EditableSpan";

import './css/ContentPages.css';
import { getFileNameFromPath } from './components/tools';

export const ExperiencesPage = () => {
    const { token } = useContext(AuthContext)
    const { pageLanguage, activeLanguage, getCurrentLanguage } = useContext(LanguagesContext);

    const [experiences, setExperiences] = useState([])
    const { request, loading, error, progress, abortUpload } = useHttp()
    const [receivedError, setReceivedError] = useState(error)
    //const [activeLanguage, setActiveLanguage] = useState([])

    //const [pageLanguage, setPageLanguage] = useState('en')

    const [experienceUpdateForm, setExperienceUpdateForm] = useState([])

    const [quizName, setQuizName] = useState('')
    const [quizUpdateForm, setQuizUpdateForm] = useState([])

    const [videoUpdateForm, setVideoUpdateForm] = useState([])
    const [videoFlatUpdateForm, setVideoFlatUpdateForm] = useState([])

    const [formVideo, setFormVideo] = useState({ key: '' })
    const [formFlatVideo, setFormFlatVideo] = useState({ key: '' })

    const updateExperienceHandler = (data, key, val) => {
        const temp = experienceUpdateForm
        if (temp.some(item => item.id === data.id)) {
            //console.log("Object found inside the array.");
            setExperienceUpdateForm(
                experienceUpdateForm => experienceUpdateForm.map(
                    item => {
                        if (item.id === data.id) {
                            item[key] = val
                        }
                        return item
                    }
                )
            )

        } else {
            //console.log("Object not found.");
            setExperienceUpdateForm([
                ...experienceUpdateForm,
                key ? { ...data, [key]: val } : data,
            ]);
        }

    }

    const updateQuizHandler = (data, key, val) => {

        const temp = quizUpdateForm
        if (temp.some(item => item.id === data.id)) {
            console.log("Object found inside the array.");
            setQuizUpdateForm(
                quizUpdateForm => quizUpdateForm.map(
                    item => {
                        if (item.id === data.id) {
                            item[key] = val
                        }
                        return item
                    }
                )
            )

        } else {
            console.log("Object not found.");
            setQuizUpdateForm([...quizUpdateForm, data])
        }
    }



    const fetchExperiences = useCallback(async () => {
        try {
            const fetched = await request('/experience/all', 'GET', null, {
                'x-access-token': token
            })

            if (fetched.experiences) {
                //console.log(fetched.experiences);
                setExperiences(fetched.experiences)
            }
            else
                console.log(fetched);

        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])

    useEffect(() => {
        fetchExperiences()
    }, [fetchExperiences])


    const deleteExperience = async (val) => {
        try {
            const data = await request(`/experience/remove/${val}`, 'POST', null, {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setExperiences(
                    experiences => experiences
                        .filter(item => item.id !== val)
                        .sort((a, b) => a.index - b.index)
                        .map((item, index) => {
                            return {
                                ...item,
                                index,
                            }
                        })
                );
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteQuiz = async (val) => {
        try {
            const data = await request(`/quiz/remove/${val}`, 'POST', null, {
                'x-access-token': token
            })

            if (data.changed === 1) {
                // setExperiences(experiences => experiences.filter(item => item.id !== val))
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            let new_quiz = item.quiz.filter(quiz_item => quiz_item.id !== val).map((quiz_item, index) => {
                                quiz_item.index = index
                                return quiz_item
                            })
                            item.quiz = new_quiz
                            return item;
                        }
                    )
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeExperienceName = async (experience_id) => {
        //console.log('form to send', experienceUpdateForm);

        let data_form = experienceUpdateForm.filter(item => {
            return item.id === experience_id
        })

        //data_form[0].name = value;

        try {
            const data = await request(`/experience/${experience_id}/update/name`, 'POST', data_form[0], {
                'x-access-token': token
            })

            if (data.changed === 1) {
                //if request failed changed name to default
                //console.log('name should be changed');
                setExperiences(
                    experiences => experiences.map(
                        item => {

                            if (item.id === experience_id) {
                                activeLanguage.map((lang_item, index) =>
                                    item['name_' + lang_item.code] = data_form[0]['name_' + lang_item.code]
                                )
                            }

                            return item
                        }
                    )
                )
            }
            setExperienceUpdateForm(experience => experience.filter(item => item.id !== experience_id))
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeExperienceDescription = async (experience_id) => {  // todo: later?
        //console.log('form to send', experienceUpdateForm);

        let data_form = experienceUpdateForm.filter(item => {
            return item.id === experience_id
        })

        try {
            const data = await request(`/experience/${experience_id}/update/description`, 'POST', data_form[0], {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            if (item.id === experience_id) {
                                return { ...item, description: data_form[0].description }
                            }
                            return item
                        }
                    )
                )
            }
            setExperienceUpdateForm(experience => experience.filter(item => item.id !== experience_id))
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeQuiz = async (quiz_id) => {
        try {
            let data_form = quizUpdateForm.filter(item => {
                return item.id === quiz_id
            })
            const data = await request(`/quiz/update/${quiz_id}`, 'POST', data_form[0], {
                'x-access-token': token
            })

            if (data.changed === 1) {
                //if request succes - change name
                console.log('name should be changed');
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            item.quiz.map(quiz_item => {
                                if (quiz_item.id === quiz_id) {
                                    quiz_item.name = data_form[0].name
                                }
                                return quiz_item
                            })

                            return item
                        }
                    )
                )
            }
            setQuizUpdateForm(quiz => quiz.filter(item => item.id !== quiz_id))
        } catch (e) {
            setReceivedError(e)
        }
    }

    const addExperience = async (formExperience) => {
        try {
            const data = await request('/experience/add', 'POST', formExperience, {
                'x-access-token': token
            })


            if (data.experience) {
                setExperiences(experiences => [...experiences, data.experience[0]])
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const addQuiz = async (experienceId) => {
        try {
            const data = await request('/quiz/add', 'POST', { name: quizName, experienceId: experienceId }, {
                'x-access-token': token
            })

            if (data.quiz) {
                // setExperiences(experiences => [...experiences, data.experience[0]] )
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            if (item.id === experienceId)
                                if (item.quiz && item.quiz.length) {
                                    item.quiz = [...item.quiz, data.quiz[0]]
                                } else {
                                    item.quiz = [data.quiz[0]]
                                }
                            // item.quiz = [...item.quiz, data.quiz[0]]
                            return item;
                        }
                    )
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }


    const changeIndex = async (upperId, lowerId) => {
        try {
            const data = await request(`/experience/index_change/${upperId}/${lowerId}`, 'POST', { type: 'experience' }, {
                'x-access-token': token
            })

            if (data.upper_changed === 1 && data.lower_changed === 1) {
                //if request success change name
                console.log('name should be changed');

                setExperiences(
                    experiences => experiences.map(
                        item => {
                            if (item.id === upperId) {
                                return {
                                    ...item,
                                    index: item.index - 1,
                                }
                            }

                            if (item.id === lowerId) {
                                return {
                                    ...item,
                                    index: item.index + 1,
                                }
                            }

                            return item
                        }
                    )
                )
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeQuizIndex = async (upperId, lowerId) => {
        try {
            const data = await request(`/experience/index_change/${upperId}/${lowerId}`, 'POST', { type: 'quiz' }, {
                'x-access-token': token
            })

            if (data.upper_changed === 1 && data.lower_changed === 1) {
                //if request success change name
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            item.quiz.map(quiz_item => {
                                if (quiz_item.id === upperId) {
                                    quiz_item.index = quiz_item.index - 1
                                }

                                if (quiz_item.id === lowerId) {
                                    quiz_item.index = quiz_item.index + 1
                                }

                                return quiz_item
                            })

                            return item
                        }
                    )
                )
            }

        } catch (e) {
            setReceivedError(e)
        }
    }


    const changeVideoHandler = (event, type) => {
        if (type === '360') {
            setFormVideo({ ...formVideo, [event.target.name]: event.target.value })
        } else {
            setFormFlatVideo({ ...formFlatVideo, [event.target.name]: event.target.value })
        }

    }

    const updateVideoHandler = (type, data, key, val) => {
        // const temp = videoUpdateForm
        let temp

        if (type === '360') {
            temp = videoUpdateForm
        } else {
            temp = videoFlatUpdateForm
        }

        if (temp.some(item => item.id === data.id)) {
            console.log("Object found inside the array.");
            if (type === '360') {
                setVideoUpdateForm(
                    videoUpdateForm => videoUpdateForm.map(
                        item => {
                            if (item.id === data.id) {
                                item[key] = val
                            }
                            return item
                        }
                    )
                )
            } else {
                setVideoFlatUpdateForm(
                    videoFlatUpdateForm => videoFlatUpdateForm.map(
                        item => {
                            if (item.id === data.id) {
                                item[key] = val
                            }
                            return item
                        }
                    )
                )
            }
        } else {
            console.log("Object not found.");
            if (type === '360') {
                setVideoUpdateForm([...videoUpdateForm, data])
            } else {
                setVideoFlatUpdateForm([...videoFlatUpdateForm, data])
            }
        }
    }


    const addVideo = async (video_type, experienceId) => {
        try {
            let form
            if (video_type === '360') {
                form = formVideo
            } else {
                form = formFlatVideo
            }
            form.type = video_type
            let data = await request(`/video/add/${experienceId}`, 'POST', form, {
                'x-access-token': token
            })
            if (data.video) {
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            if (item.id === experienceId)
                                if (item['video_' + video_type] && item['video_' + video_type].length) {
                                    item['video_' + video_type] = [...item['video_' + video_type], data.video[0]]
                                } else {
                                    item['video_' + video_type] = [data.video[0]]
                                }
                            return item;
                        }
                    )
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeVideo = async (type, video_id) => {
        try {
            let temp
            if (type === '360') {
                temp = videoUpdateForm
            } else {
                temp = videoFlatUpdateForm
            }

            let data_form = temp.filter(item => {
                return item.id === video_id
            })


            let data = await request(`/video/update_${type}/${video_id}`, 'POST', data_form[0], {
                'x-access-token': token
            })


            if (data.changed === 1) {
                //if request success change video
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            item['video_' + type] = item['video_' + type].map(video_item => {
                                if (video_item.id === video_id) {
                                    // video_item.name = data_form[0].name
                                    // video_item.type = data_form[0].type
                                    // video_item.split = data_form[0].split
                                    // video_item.mode = data_form[0].mode
                                    video_item = data_form[0]
                                }
                                return video_item
                            })

                            return item
                        }
                    )
                )
            }
            if (type === '360') {
                setVideoUpdateForm(video => video.filter(item => item.id !== video_id))
            } else {
                setVideoFlatUpdateForm(video => video.filter(item => item.id !== video_id))
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteVideo = async (type, video_id) => {
        try {
            const data = await request(`/video/remove/${video_id}/${type}`, 'GET', null, {
                'x-access-token': token
            })
            // 
            if (data.changed === 1) {
                // setVideo(video => video.filter(item => item.id !== video_id))

                setExperiences(
                    experiences => experiences.map(
                        item => {
                            let new_videos = item['video_' + type].filter(video_item => video_item.id !== video_id).map((video_item, index) => {
                                video_item.index = index
                                return video_item
                            })
                            item['video_' + type] = new_videos
                            return item;
                        }
                    )
                )
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const actionVideoFile = async (action, video_id, type, file, video_item_default) => {

        try {
            let data
            if (action === 'upload') {
                const form_data = new FormData()
                form_data.append('video', file, file.name)
                //form_data.append('video_name', file.name)

                data = await request(`/video/upload/${type}/${video_id}`, 'POST', form_data, {
                    'x-access-token': token,
                    'Content-Type': 'multipart/form-data'
                }, true)
            } else if (action === 'delete') {
                data = await request(`/video/file_remove/${type}/${video_id}/${getFileNameFromPath(file)}`, 'GET', null, {
                    'x-access-token': token
                })
            }


            if (data.video) {

                setExperiences(
                    experiences => experiences.map(
                        item => {

                            const videoType = 'video_' + type;
                            if (item[videoType]?.length) {

                                item[videoType] = item[videoType].map(video_item => {
                                    if (video_item.id === video_id) {
                                        if (action === 'upload')
                                            video_item = data.video[0];
                                        else if (action === 'delete')
                                            video_item.file = null
                                    }
                                    return video_item
                                })
                            }

                            return item
                        }
                    )
                )
                if (type === '360') {
                    updateVideoHandler(type, video_item_default, 'file', data.video[0].file);
                }

            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeVideoIndex = async (upperId, lowerId, type) => {
        try {
            const data = await request(`/experience/index_change/${upperId}/${lowerId}`, 'POST', { type: 'video_' + type }, {
                'x-access-token': token
            })

            if (data.upper_changed === 1 && data.lower_changed === 1) {
                //if request success change name
                setExperiences(
                    experiences => experiences.map(
                        item => {
                            item['video_' + type] = item['video_' + type].map(video_item => {
                                if (video_item.id === upperId) {
                                    video_item.index = video_item.index - 1
                                }

                                if (video_item.id === lowerId) {
                                    video_item.index = video_item.index + 1
                                }

                                return video_item
                            })

                            return item
                        }
                    )
                )
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    const actionPreviewFile = useCallback(async (action, imageFile, exp) => {
        try {
            let data

            if (action === 'upload') {

                const form_data = new FormData()
                form_data.append('image', imageFile, imageFile.name)

                data = await request(`/experience/${exp.id}/upload/preview`, 'POST', form_data, {
                    'x-access-token': token,
                    'Content-Type': 'multipart/form-data'
                }, true)

                if (!data.error)
                    setExperiences(experiences => experiences.map(item => item.id === exp.id ? { ...item, preview: data.preview } : item))

            } else {
                data = await request(`/experience/${exp.id}/remove/preview/${getFileNameFromPath(imageFile)}`, 'GET', null, {
                    'x-access-token': token
                })

                if (!data?.error)
                    setExperiences(experiences => experiences.map(item => item.id === exp.id ? { ...item, preview: null } : item))
            }

        } catch (e) {
            setReceivedError(e)
        }
    }, [error, request, token]);

    return (
        <>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            {loading && <Loader progress={progress} cancelState={abortUpload} />}
            <h3 className="FormTitle">Experiences List</h3>

            <NewFormBlock languageData={getCurrentLanguage()} addAction={addExperience} loadingState={loading} buttonLabel={'Add Experience'} placeholderText={"Enter experience name on " + getCurrentLanguage().name} />

            {(experiences && experiences.length)
                ?
                <div>
                    {experiences.filter(exp => exp.language === pageLanguage).sort((a, b) => a.index - b.index).map((exp, index, array) =>
                        <div className="CardBlock BoxShadow mb-5" key={exp.id}>
                            <Tabs className="CardBlockHeder" defaultActiveKey="video_flat">
                                <Tab
                                    tabClassName="CardBlockHederTabArrows"
                                    title={<div className="d-flex flex-column ">
                                        <IconContext.Provider value={{ color: "#ccc" }}>
                                            {array[index - 1] &&
                                                <FaSortUp onClick={() => changeIndex(exp.id, array[index - 1].id)} />}
                                            {array[index + 1] &&
                                                <FaSortDown onClick={() => changeIndex(array[index + 1].id, exp.id)} />}
                                        </IconContext.Provider>
                                    </div>}
                                />

                                <Tab
                                    tabClassName="CardBlockHederTabName"
                                    title={<div className="align-experiences-start d-flex" onClick={() => {
                                        let default_data = { id: exp.id }
                                        activeLanguage.map((lang_item, index) =>
                                            default_data['name_' + lang_item.code] = exp['name_' + lang_item.code]
                                        )
                                        updateExperienceHandler(default_data)
                                    }}>

                                        {activeLanguage.length && activeLanguage
                                            .filter(lang => lang.code === pageLanguage)
                                            .map((lang_item, index) =>
                                                <div key={lang_item.name} >
                                                    <EditableSpan
                                                        key={index}
                                                        item={exp}
                                                        updateHandler={updateExperienceHandler}
                                                        fieldName={'name_'}
                                                        langCode={lang_item.code}
                                                        textValue={exp['name_' + lang_item.code]}
                                                    />
                                                </div>
                                            )}

                                    </div>}


                                />

                                {experienceUpdateForm.some(experienceUpdateForm => experienceUpdateForm.id === exp.id && experienceUpdateForm.updated === 1)
                                    &&
                                    <Tab
                                        tabClassName="CardBlockHederTab"
                                        title={
                                            <img src="/img/save.png"
                                                onClick={() => changeExperienceName(exp.id)}
                                                className="CardBlockHederImg" alt="" />
                                        }
                                    />
                                }


                                <Tab
                                    tabClassName="CardBlockHederTab"
                                    eventKey="video_flat"
                                    title={
                                        <div>
                                            <img src="/img/FlatVideo.png" className="TabBlockImg" alt="" />
                                        </div>
                                    }
                                >
                                    <div className="mt-1 mb-2 ">
                                        <div className="TabInputBlock">
                                            <input
                                                className="FormInput BoxShadow"
                                                type="text"
                                                placeholder="Name"
                                                name="name"
                                                onChange={(e) => changeVideoHandler(e, "flat")}
                                            />
                                            <button
                                                className="ElementButton"
                                                type="submit"
                                                variant="success"
                                                disabled={loading}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    addVideo("flat", exp.id);
                                                }}
                                            >
                                                Add Video
                                            </button>
                                        </div>
                                    </div>

                                    <table className="Table">
                                        <thead>
                                            <tr className="TableBlock">
                                                <th className="TableFirstLineBlock">Sort</th>
                                                <th className="TableFirstLineBlock">Name</th>
                                                <th className="TableFirstLineBlock">Video Flat</th>
                                                <th className="TableFirstLineBlock">Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {exp.video_flat && exp.video_flat.length ? (
                                                exp.video_flat
                                                    .sort((a, b) => a.index - b.index)
                                                    .map((video_item, index, array) => (
                                                        <tr
                                                            key={video_item.id}
                                                            onClick={() => {
                                                                let default_data = {
                                                                    id: video_item.id,
                                                                    name: video_item.name,
                                                                    file: video_item.file,
                                                                };
                                                                updateVideoHandler("flat", default_data);
                                                            }}
                                                        >
                                                            <td className="TableSecondLineBlock CenterExperiences ">
                                                                <div className="d-inline-flex flex-column">
                                                                    <IconContext.Provider value={{ color: "white" }}>

                                                                        {array[index - 1] && (
                                                                            <FaSortUp
                                                                                className="d-flex flex-column"
                                                                                onClick={() =>
                                                                                    changeVideoIndex(
                                                                                        video_item.id,
                                                                                        array[index - 1].id,
                                                                                        "flat"
                                                                                    )
                                                                                }
                                                                            />
                                                                        )}

                                                                        {array[index + 1] && (
                                                                            <FaSortDown
                                                                                className="d-flex flex-column "
                                                                                onClick={() =>
                                                                                    changeVideoIndex(
                                                                                        array[index + 1].id,
                                                                                        video_item.id,
                                                                                        "flat"
                                                                                    )
                                                                                }
                                                                            />
                                                                        )}
                                                                    </IconContext.Provider>
                                                                </div>
                                                            </td>

                                                            <td
                                                                className="TableSecondLineBlock TableSecondLineText TableSecondLineInput"
                                                                onKeyPress={(e) => {
                                                                    if (e.which === 13 || e.keyCode === 13) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                onInput={(e) => {
                                                                    const val = e.currentTarget.textExperiences;
                                                                    let data = video_item;
                                                                    updateVideoHandler("flat", data, "name", val);
                                                                    updateVideoHandler("flat", data, "updated", 1);
                                                                }}
                                                                editable="true"
                                                            >
                                                                {video_item.name}
                                                            </td>
                                                            {video_item.file &&
                                                                video_item.file.length &&
                                                                video_item.file !== null ? (
                                                                <td className="TableSecondLineBlock TableSecondLineText">
                                                                    {getFileNameFromPath(video_item.file)}
                                                                    <img
                                                                        src="/img/TrashB.png" alt=""
                                                                        onClick={() => {
                                                                            if (window.confirm("Delete this item?")) {
                                                                                actionVideoFile(
                                                                                    "delete",
                                                                                    video_item.id,
                                                                                    "flat",
                                                                                    video_item.file,
                                                                                    video_item
                                                                                );
                                                                            }
                                                                        }}
                                                                        className="text-danger mx-4 TableSecondLineImg"
                                                                    />
                                                                    <a
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        href={`${process.env.REACT_APP_API
                                                                            }/static/video_flat/${video_item.id
                                                                            }/${encodeURIComponent(getFileNameFromPath(video_item.file))}`}
                                                                    >
                                                                        <img
                                                                            src="/img/Edit.png" alt=""
                                                                            className="TableSecondLineImg"
                                                                        />
                                                                    </a>
                                                                </td>
                                                            ) : (
                                                                <td className="TableSecondLineBlock ">
                                                                    <label htmlFor={`video_flat_input-${video_item.id}`}>
                                                                        <input
                                                                            type="file"
                                                                            id={`video_flat_input-${video_item.id}`}
                                                                            name="video_flat_file"
                                                                            style={{ display: "none" }}
                                                                            onChange={(e) => {
                                                                                if (window.confirm("Upload this file?")) {

                                                                                    actionVideoFile(
                                                                                        "upload",
                                                                                        video_item.id,
                                                                                        "flat",
                                                                                        e.target.files[0],
                                                                                        video_item
                                                                                    );
                                                                                }
                                                                            }}
                                                                        />
                                                                        <img src="/img/Upload.png"
                                                                            className="TableSecondLineImg"
                                                                            alt="Upload new file"
                                                                        />
                                                                        <span className="TableSecondLineText mx-2">Select file..</span>
                                                                    </label>
                                                                </td>
                                                            )}
                                                            <td className="TableSecondLineBlock CenterExperiences">
                                                                {videoFlatUpdateForm.some(
                                                                    (array_item) =>
                                                                        array_item.id === video_item.id &&
                                                                        array_item.updated === 1
                                                                ) && (
                                                                        <img
                                                                            src="/img/save_white.png" alt=""
                                                                            onClick={() => changeVideo("flat", video_item.id)}
                                                                            className="TableSecondLineImg mx-4"
                                                                        />
                                                                    )}
                                                                <img
                                                                    src="/img/TrashB.png"
                                                                    alt="" onClick={() => {
                                                                        if (window.confirm("Delete this item?")) {
                                                                            deleteVideo("flat", video_item.id);
                                                                        }
                                                                    }}
                                                                    className="text-danger mx-1 TableSecondLineImg"
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr className="NoElementsText"><td>No Videos</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Tab>

                                <Tab
                                    tabClassName="CardBlockHederTab"
                                    eventKey="video_360"
                                    title={<img src="/img/360.png" className="TabBlockImg" alt="" />}
                                    className="test"
                                >
                                    <div className="mt-1 mb-2 ">
                                        <div className="TabInputBlock">
                                            <input
                                                className="FormInput BoxShadow"
                                                type="text"
                                                placeholder="Name"
                                                name="name"
                                                onChange={(e) => changeVideoHandler(e, "360")}
                                            />
                                            <button
                                                className="ElementButton"
                                                type="submit"
                                                // variant="success"
                                                disabled={loading}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    addVideo("360", exp.id);
                                                }}
                                            >
                                                Add Video
                                            </button>
                                        </div>
                                    </div>

                                    <table className="Table">
                                        <thead>
                                            <tr className="TableBlock">
                                                <th className="TableFirstLineBlock">Sort</th>
                                                <th className="TableFirstLineBlock">Name</th>
                                                <th className="TableFirstLineBlock">Video 360</th>
                                                <th className="TableFirstLineBlock">Type</th>
                                                <th className="TableFirstLineBlock">Mode</th>
                                                <th className="TableFirstLineBlock">Split</th>
                                                <th className="TableFirstLineBlock">Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {exp.video_360 && exp.video_360.length ? (
                                                exp.video_360
                                                    .sort((a, b) => a.index - b.index)
                                                    .map((video_item, index, array) => (
                                                        <tr
                                                            key={video_item.id}
                                                            onClick={() => {
                                                                let default_data = {
                                                                    id: video_item.id,
                                                                    name: video_item.name,
                                                                    type: video_item.type,
                                                                    mode: video_item.mode,
                                                                    split: video_item.split,
                                                                    file: video_item.file,
                                                                };
                                                                updateVideoHandler("360", default_data);
                                                            }}
                                                        >
                                                            <td className="TableSecondLineBlock CenterExperiences ">
                                                                <div className="d-inline-flex flex-column">
                                                                    <IconContext.Provider value={{ color: "white" }}>

                                                                        {array[index - 1] && (
                                                                            <FaSortUp
                                                                                className="d-flex flex-column "
                                                                                onClick={() =>
                                                                                    changeVideoIndex(
                                                                                        video_item.id,
                                                                                        array[index - 1].id,
                                                                                        "360"
                                                                                    )
                                                                                }
                                                                            />
                                                                        )}

                                                                        {array[index + 1] && (
                                                                            <FaSortDown
                                                                                className="d-flex flex-column "
                                                                                onClick={() =>
                                                                                    changeVideoIndex(
                                                                                        array[index + 1].id,
                                                                                        video_item.id,
                                                                                        "360"
                                                                                    )
                                                                                }
                                                                            />
                                                                        )}
                                                                    </IconContext.Provider>
                                                                </div>
                                                            </td>

                                                            <td
                                                                className="TableSecondLineBlock TableSecondLineText"
                                                                onKeyPress={(e) => {
                                                                    if (e.which === 13 || e.keyCode === 13) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                onInput={(e) => {
                                                                    const val = e.currentTarget.textExperiences;
                                                                    let data = video_item;
                                                                    updateVideoHandler("360", data, "name", val);
                                                                    updateVideoHandler("360", data, "updated", 1);
                                                                }}
                                                                editable="true"
                                                            >
                                                                {video_item.name}
                                                            </td>

                                                            {video_item.file &&
                                                                video_item.file.length &&
                                                                video_item.file !== null ? (
                                                                <td className="TableSecondLineBlock TableSecondLineText">
                                                                    {getFileNameFromPath(video_item.file)}
                                                                    <img
                                                                        src="/img/TrashB.png" alt=""
                                                                        onClick={() => {
                                                                            if (window.confirm("Delete this item?")) {
                                                                                actionVideoFile(
                                                                                    "delete",
                                                                                    video_item.id,
                                                                                    "360",
                                                                                    video_item.file,
                                                                                    video_item
                                                                                );
                                                                            }
                                                                        }}
                                                                        className="text-danger mx-4 TableSecondLineImg"
                                                                    />
                                                                    <a
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        href={`${process.env.REACT_APP_API
                                                                            }/static/video_360/${video_item.id
                                                                            }/${encodeURIComponent(getFileNameFromPath(video_item.file))}`}
                                                                    >
                                                                        <img
                                                                            src="/img/Edit.png"
                                                                            className="TableSecondLineImg" alt=""
                                                                        />
                                                                    </a>
                                                                </td>
                                                            ) : (
                                                                <td className="TableSecondLineBlock TableSecondLineText">
                                                                    <label
                                                                        className="Video360Block"
                                                                        htmlFor={`video_360_input-${video_item.id}`}
                                                                    >
                                                                        <input
                                                                            type="file"
                                                                            id={`video_360_input-${video_item.id}`}
                                                                            name="video_360_file"
                                                                            style={{ display: "none" }}
                                                                            onChange={(e) => {
                                                                                if (window.confirm("Upload this file?")) {
                                                                                    actionVideoFile(
                                                                                        "upload",
                                                                                        video_item.id,
                                                                                        "360",
                                                                                        e.target.files[0],
                                                                                        video_item
                                                                                    );
                                                                                }
                                                                            }}
                                                                        />
                                                                        <img
                                                                            src="/img/Upload.png"
                                                                            className="text-warning TableSecondLineImg"
                                                                            alt="Upload new file"
                                                                        />
                                                                        <span
                                                                            className="mx-2 FileUploadText">Select file..</span>
                                                                    </label>
                                                                </td>
                                                            )}
                                                            <td className="TableSecondLineBlock">
                                                                <div>
                                                                    <div
                                                                        className="TableSecondLineForm"
                                                                    //controlId="exampleForm.SelectCustom"
                                                                    >
                                                                        <select
                                                                            className="TableFormBlock"
                                                                            //as="select"
                                                                            //custom
                                                                            onChange={(e) => {
                                                                                console.log(
                                                                                    "log select was changed",
                                                                                    e.target.value
                                                                                );
                                                                                let select = e.target.value;
                                                                                let data = video_item;
                                                                                updateVideoHandler("360", data, "type", select);
                                                                                updateVideoHandler("360", data, "updated", 1);
                                                                            }}
                                                                            style={{
                                                                                minWidth: "75px",
                                                                            }}
                                                                            defaultValue={video_item.type}
                                                                        >
                                                                            <option disabled> -- select an option --
                                                                            </option>
                                                                            <option>Flat</option>
                                                                            <option>Panorama</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="TableSecondLineBlock">
                                                                <div>
                                                                    <div
                                                                        className="TableSecondLineForm"
                                                                    // controlId="exampleForm.SelectCustom"
                                                                    >
                                                                        <select
                                                                            className="TableFormBlock"
                                                                            //as="select"
                                                                            //custom
                                                                            onChange={(e) => {
                                                                                let select = e.target.value;
                                                                                let data = video_item;
                                                                                updateVideoHandler("360", data, "mode", select);
                                                                                updateVideoHandler("360", data, "updated", 1);
                                                                            }}
                                                                            style={{
                                                                                minWidth: "75px",
                                                                            }}
                                                                            defaultValue={video_item.mode}
                                                                        >
                                                                            <option disabled> -- select an option --
                                                                            </option>
                                                                            <option>None</option>
                                                                            <option>Transparent</option>
                                                                            <option>Stereo</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="TableSecondLineBlock">
                                                                <div>
                                                                    <div
                                                                        className="TableSecondLineForm"
                                                                    //controlId="exampleForm.SelectCustom"
                                                                    >
                                                                        <select
                                                                            className="TableFormBlock"
                                                                            // as="select"
                                                                            // custom
                                                                            onChange={(e) => {
                                                                                let select = e.target.value;
                                                                                let data = video_item;
                                                                                updateVideoHandler(
                                                                                    "360",
                                                                                    data,
                                                                                    "split",
                                                                                    select
                                                                                );
                                                                                updateVideoHandler("360", data, "updated", 1);
                                                                            }}
                                                                            style={{
                                                                                minWidth: "75px",
                                                                            }}
                                                                            defaultValue={video_item.split}
                                                                        >
                                                                            <option disabled> -- select an option --
                                                                            </option>
                                                                            <option>None</option>
                                                                            <option>Vertical</option>
                                                                            <option>Horizontal</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="TableSecondLineBlock CenterExperiences ">
                                                                {videoUpdateForm.some(
                                                                    (array_item) =>
                                                                        array_item.id === video_item.id &&
                                                                        array_item.updated === 1
                                                                ) && (
                                                                        <img
                                                                            src="/img/save_white.png" alt=""
                                                                            onClick={() => changeVideo("360", video_item.id)}
                                                                            className="text-warning mx-3 TableSecondLineImg"
                                                                        />
                                                                    )}
                                                                <img
                                                                    src="/img/TrashB.png"
                                                                    alt="" onClick={() => {
                                                                        if (window.confirm("Delete this item?")) {
                                                                            deleteVideo("360", video_item.id);
                                                                        }
                                                                    }}
                                                                    className="text-danger mx-1 TableSecondLineImg"
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr className="NoElementsText"><td>No Videos</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Tab>

                                <Tab
                                    tabClassName="CardBlockHederTab"
                                    eventKey="quiz"
                                    title={
                                        <div>
                                            <img src="/img/Quiz.png" className="TabBlockImg" alt="" />
                                        </div>
                                    }
                                >
                                    <div className="mt-3 mb-2 ">
                                        <div className="TabInputBlock">
                                            <input
                                                className="FormInput BoxShadow"
                                                type="text"
                                                name="quiz_name"
                                                placeholder="Name"
                                                onChange={(e) => setQuizName(e.target.value)}
                                            />
                                            <button
                                                className="ElementButton"
                                                type="submit"
                                                variant="success"
                                                disabled={loading}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    addQuiz(exp.id);

                                                }}
                                            >
                                                Add Quiz
                                            </button>
                                        </div>
                                    </div>

                                    <table className="Table">
                                        <thead>
                                            <tr className="TableBlock">
                                                <th className="TableFirstLineBlock">Sort</th>
                                                <th className="TableFirstLineBlock">Name</th>
                                                <th className="TableFirstLineBlock">Actions</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {exp.quiz && exp.quiz.length ? (
                                                exp.quiz
                                                    .sort((a, b) => a.index - b.index)
                                                    .map((quiz_item, index, array) => (
                                                        <tr
                                                            key={quiz_item.id}
                                                            onClick={(e) => {
                                                                updateQuizHandler({
                                                                    id: quiz_item.id,
                                                                    name: quiz_item.name,
                                                                });
                                                            }}
                                                        >
                                                            <td className="TableSecondLineBlock CenterExperiences ">
                                                                <div className="d-inline-flex flex-column">
                                                                    <IconContext.Provider value={{ color: "white" }}>

                                                                        {array[index - 1] && (
                                                                            <FaSortUp
                                                                                className="align-self-center "
                                                                                onClick={() =>
                                                                                    changeQuizIndex(quiz_item.id, array[index - 1].id)
                                                                                }
                                                                            />
                                                                        )}

                                                                        {array[index + 1] && (
                                                                            <FaSortDown
                                                                                className=""
                                                                                onClick={() =>
                                                                                    changeQuizIndex(array[index + 1].id, quiz_item.id)
                                                                                }
                                                                            />
                                                                        )}
                                                                    </IconContext.Provider>
                                                                </div>
                                                            </td>
                                                            <td key={quiz_item.id} className="TableSecondLineBlock TableSecondLineText"

                                                                onKeyPress={(e) => {
                                                                    if (e.which === 13 || e.keyCode === 13) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                onInput={(e) => {
                                                                    const val = e.currentTarget.textExperiences;
                                                                    let data = quiz_item;
                                                                    updateQuizHandler(data, "name", val);
                                                                    updateQuizHandler(data, "updated", 1);
                                                                }}
                                                                editable="true"
                                                            >
                                                                {quiz_item.name}

                                                            </td>
                                                            <td className="TableSecondLineBlock">
                                                                {quizUpdateForm.some(
                                                                    (quizUpdateForm) =>
                                                                        quizUpdateForm.id === quiz_item.id &&
                                                                        quizUpdateForm.updated === 1
                                                                ) && (
                                                                        <img
                                                                            src="/img/save_white.png" alt=""
                                                                            onClick={() => changeQuiz(quiz_item.id)}
                                                                            className="TableSecondLineImg"
                                                                        />
                                                                    )}

                                                                <Link to={`/quiz/${quiz_item.id}`}
                                                                    className="TableSecondLineImg mx-4">
                                                                    <img src="/img/Edit.png" alt="" className="TableSecondLineImg" />
                                                                </Link>

                                                                <img
                                                                    src="/img/TrashB.png"
                                                                    className="TableSecondLineImg" alt=""
                                                                    onClick={() => {
                                                                        if (window.confirm("Delete this item?")) {
                                                                            deleteQuiz(quiz_item.id);
                                                                        }
                                                                    }}
                                                                />


                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr><td><span className="NoElementsText">No Quizzes</span></td></tr>
                                            )}

                                        </tbody>
                                    </table>
                                </Tab>

                                <Tab
                                    tabClassName="CardBlockHederTab"
                                    eventKey="settings"
                                    title={
                                        <div>
                                            <img src="/img/settings.png" className="TabBlockImg" alt="" />
                                        </div>
                                    }
                                >
                                    <div className='px-3 pt-2'>
                                        <table className="w-100">
                                            <colgroup>
                                                <col width={200} />
                                                <col />
                                            </colgroup>
                                            <tr><td>
                                                <p className="FormText">Experience image:</p></td><td>
                                                    {
                                                        exp?.preview ? <div>
                                                            <img src={process.env.REACT_APP_API + exp?.preview} alt="Mobile app experience preview image" width="100" height="100" className='m-3' style={{ borderRadius: "50%" }} />
                                                            <img
                                                                src="/img/TrashB.png"
                                                                onClick={() => {
                                                                    if (window.confirm("Delete this preview?")) {
                                                                        actionPreviewFile(
                                                                            "delete",
                                                                            exp.preview,
                                                                            exp
                                                                        );
                                                                    }
                                                                }}
                                                                className="text-danger mx-4 TableSecondLineImg"
                                                                alt=""
                                                            /></div> :
                                                            <div><img src="/none.jpg" alt="no-logo" width="100" height="100" className='m-3' style={{ borderRadius: "50%" }} />
                                                                <label htmlFor={`exp_image_preview-${exp.id}`}>
                                                                    <input
                                                                        type="file"
                                                                        id={`exp_image_preview-${exp.id}`}
                                                                        name="exp_image_preview"
                                                                        style={{ display: "none" }}
                                                                        onChange={(e) => {
                                                                            if (window.confirm("Upload this file?")) {
                                                                                actionPreviewFile(
                                                                                    "upload",
                                                                                    e.target.files[0],
                                                                                    exp
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                    <img src="/img/Upload.png"
                                                                        className="TableSecondLineImg"
                                                                        alt="Upload new file"
                                                                    />
                                                                    <span className="TableSecondLineText mx-2">Select file..</span>
                                                                </label>
                                                            </div>
                                                    }
                                                </td></tr>

                                            <tr>
                                                <td><p className="FormText ">Experience description:</p></td>
                                                <td className='d-flex align-items-center'>
                                                    <input
                                                        type="text"
                                                        name="company_public_name"
                                                        placeholder='Enter text..'
                                                        className='FormInputSmall m-2'
                                                        value={exp.description || ''}
                                                        onChange={e => {
                                                            exp.description = e.target.value;
                                                            updateExperienceHandler({ id: exp.id }, 'description', e.target.value);
                                                        }}
                                                    />
                                                    <button
                                                        type="submit"
                                                        className="ButtonBlockSmall mt-0"
                                                        disabled={loading}
                                                        onClick={() => changeExperienceDescription(exp.id)}>
                                                        Save
                                                    </button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div >
                                </Tab>

                                <Tab
                                    tabClassName="CardBlockHederTabTresh CenterExperiences"
                                    title={
                                        //<span className="small">{item.id} </span>
                                        <img src="/img/Trash.png" alt="" className="CardBlockHederImgSmall" onClick={() => {
                                            if (window.confirm('Delete this item?')) {
                                                deleteExperience(exp.id)
                                            }
                                        }} />
                                    }
                                />
                            </Tabs>


                        </div>
                    )

                    }
                </div>
                : <span className="NoElementsText">No Data</span>}


        </>
    )
}
